export default "__VITE_ASSET__Dp7BUD2i__"